import { FC, useState } from 'react';
import { X } from 'lucide-react';

export const Disclaimer: FC = () => {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div
      className="fill-lost relative p-3 pr-9"
      style={{
        border: '2px solid var(--nb-ink)',
        boxShadow: '3px 3px 0 var(--nb-ink)',
        borderRadius: 'var(--nb-radius)',
      }}
    >
      <button
        onClick={() => setVisible(false)}
        className="absolute right-1.5 top-1.5 p-1"
        aria-label="Cerrar aviso"
      >
        <X size={16} />
      </button>
      <div
        className="text-[10px] font-bold uppercase tracking-[0.08em] opacity-70"
        style={{ fontFamily: '"JetBrains Mono", monospace' }}
      >
        / importante
      </div>
      <div className="font-display mt-0.5 text-[16px] leading-tight">
        Solo perdidos o encontrados.
      </div>
      <p className="mt-1.5 text-[12px] font-medium leading-snug">
        RescatApp no es para publicar animales en <strong>venta</strong> o{' '}
        <strong>adopción</strong>. Esas publicaciones se eliminan.
      </p>
    </div>
  );
};
